import NewFeaturesContainer from './NewFeaturesContainer';

export default NewFeaturesContainer;
